import React from 'react';

export const ShutterRightOpening = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 61 77.8"
      width="48"
      {...props}
    >
      <path fill="#fff" d="M3.2.8h54.6v67.8H3.2z" />
      <path
        d="M2.7 68.6V.8c0-.5.2-.8.5-.8h54.6c.2 0 .4.3.4.8v67.8c0 .4-.2.8-.4.8H3.2c-.3-.1-.5-.4-.5-.8zm54.6-67H3.6v66.2h53.7V1.6z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M3.2.8h54.6v67.8H3.2z" />
      <path
        d="M2.7 68.6V.8c0-.5.2-.8.5-.8h54.6c.2 0 .4.3.4.8v67.8c0 .4-.2.8-.4.8H3.2c-.3-.1-.5-.4-.5-.8zm54.6-67H3.6v66.2h53.7V1.6z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M5.7 5.3h49.5v58.8H5.7z" />
        <path d="M5.7 64.9c-.2 0-.4-.4-.4-.8V5.3c0-.4.2-.8.4-.8h49.5c.2 0 .4.3.4.8v58.8c0 .4-.2.8-.4.8H5.7zM54.8 6H6.2v57.3h48.6V6z" />
      </g>
      <path
        d="M.4 69.3h60.1c.2 0 .4-.3.4-.7 0-.4-.2-.7-.4-.7H.4c-.2 0-.4.3-.4.7 0 .4.2.7.4.7z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M54.9 1.7l-42.8 8.4-.2 66.7 43-9.1z" />
        <path
          d="M11.3 9.4L55.7.7v67.7l-44.6 9.4.2-68.4zm42.9-6.8l-41.4 8.1-.2 65L54.2 67V2.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M50.4 9.5l-34 6.8V21l34-6.7z" />
        <path
          d="M16 15.9L50.8 9v5.6l-34.8 7v-5.7zM50 10l-33.2 6.6v3.9L50 13.9V10z"
          fill="#fff"
        />
        <path fill="#233762" d="M50.4 14.3l-34 6.7-.1 4.8L50.4 19z" />
        <path
          d="M16 20.7l34.8-6.9v5.6l-34.8 7v-5.7zm34-5.9l-33.2 6.6v3.9L50 18.7v-3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M50.4 19l-34.1 6.8v4.8l34.1-6.8z" />
        <path
          d="M15.9 25.5l34.8-7v5.6l-34.9 7 .1-5.6zm34.1-6l-33.3 6.7v3.9L50 23.4v-3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M50.4 23.8l-34.1 6.8v4.8l34.1-6.9z" />
        <path
          d="M15.9 30.3l34.9-7v5.6l-34.9 7v-5.6zm34.1-6L16.7 31v3.9L50 28.2v-3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M50.4 28.5l-34.1 6.9v4.8l34.1-6.9z" />
        <path
          d="M15.9 35.1l34.9-7v5.6l-34.9 7.1v-5.7zm34.1-6l-33.3 6.7v3.9L50 32.9v-3.8z"
          fill="#fff"
        />
        <path fill="#233762" d="M50.4 33.3l-34.1 6.9V45l34.1-6.9z" />
        <path
          d="M15.9 39.9l34.9-7.1v5.6l-34.9 7.1v-5.6zM50 33.8l-33.3 6.8v3.9L50 37.7v-3.9z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M50.4 38.1L16.3 45v4.8l34.1-7z" />
          <path
            d="M15.9 44.7l34.9-7.1v5.6l-34.9 7.2v-5.7zM50 38.6l-33.3 6.8v3.9L50 42.5v-3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M50.4 42.8l-34.1 7v4.8l34.1-7z" />
          <path
            d="M15.9 49.5l34.9-7.2v5.6l-34.9 7.2v-5.6zM50 43.3l-33.3 6.8V54L50 47.2v-3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M50.4 47.6l-34.1 7v4.8l34.1-7.1z" />
          <path
            d="M15.9 54.3l34.9-7.2v5.6l-34.9 7.2v-5.6zM50 48.1L16.7 55v3.9L50 52v-3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M50.4 52.4l-34.1 7.1-.1 4.8 34.2-7.2z" />
          <path
            d="M15.9 59.1l34.9-7.2v5.6l-34.9 7.3v-5.7zM50 52.9l-33.3 6.9v3.9L50 56.8v-3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M50.4 57.1l-34.2 7.2v4.8l34.2-7.2z" />
          <path
            d="M15.8 63.9l34.9-7.3v5.6l-34.9 7.3v-5.6zM50 57.7l-33.3 6.9v3.9l33.3-7v-3.8z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M34.4 12.7l-2.2.4-.1 52.6 2.2-.4z" />
      </g>
    </svg>
  );
};
